import { render, staticRenderFns } from "./T1TopOfferCard.vue?vue&type=template&id=511573a2&scoped=true&"
import script from "./T1TopOfferCard.vue?vue&type=script&lang=js&"
export * from "./T1TopOfferCard.vue?vue&type=script&lang=js&"
import style0 from "./T1TopOfferCard.vue?vue&type=style&index=0&id=511573a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511573a2",
  null
  
)

export default component.exports